import { HorizontalSliderForm } from "./horizontal-slider-form";
import { HorizontalSliderHandler } from "./horizontal-slider-handler";

export class HorizontalSliderListener {
    private readonly form: HorizontalSliderForm;

    private readonly handler: HorizontalSliderHandler;

    public constructor(form: HorizontalSliderForm, handler: HorizontalSliderHandler) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        const root = this.form.getRoot();
        const track = this.form.getTrack();
        const prevButton = this.form.getPrevButton();
        const nextButton = this.form.getNextButton();

        if (!(track instanceof HTMLElement)) return;

        prevButton?.addEventListener("click", this.handler.handlePrevClick.bind(this.handler));
        nextButton?.addEventListener("click", this.handler.handleNextClick.bind(this.handler));

        track.addEventListener("scroll", this.handler.handleTrackScroll.bind(this.handler), { passive: true });
        window.addEventListener("resize", this.handler.handleResize.bind(this.handler), { passive: true });

        root.addEventListener("mouseenter", this.handler.handleMouseEnter.bind(this.handler));
        root.addEventListener("mouseleave", this.handler.handleMouseLeave.bind(this.handler));
        root.addEventListener("focusin", this.handler.handleFocusIn.bind(this.handler));
        root.addEventListener("focusout", this.handler.handleFocusOut.bind(this.handler));

        root.addEventListener("click", (event) => {
            const dot = this.form.getClosestDot(event.target);
            if (!(dot instanceof HTMLButtonElement)) return;
            this.handler.handleDotClick(dot);
        });

        track.addEventListener("wheel", this.handler.handleManualInteraction.bind(this.handler), { passive: true });
        track.addEventListener("pointerdown", this.handler.handleManualInteraction.bind(this.handler), {
            passive: true,
        });
        track.addEventListener("touchstart", this.handler.handleManualInteraction.bind(this.handler), {
            passive: true,
        });
        track.addEventListener("load", this.handler.handleTrackContentLoad.bind(this.handler), true);
    }
}
